const api = "https://dents.ingeniosvirtuales.com/api/";
// const api = "http://127.0.0.1:8000/api/";
export default api;